import { render, staticRenderFns } from "./PopupViewProfilePersonal.vue?vue&type=template&id=c327e59e&scoped=true"
import script from "./PopupViewProfilePersonal.vue?vue&type=script&lang=js"
export * from "./PopupViewProfilePersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c327e59e",
  null
  
)

export default component.exports